import angular from 'angular';
import confirmationOrderComponent from './confirmation-order.component';
import ConfirmationOrderService from './confirmation-order.service';
import ModalExperienceController from './modal-experience/modal-experience.controller';

let confirmationOrderModule = angular.module('app.confirmationOrder',[])
   .controller('ModalExperienceController', ModalExperienceController)
  .component('confirmationOrder', confirmationOrderComponent)
  .service('ConfirmationOrderService', ConfirmationOrderService);

export default confirmationOrderModule;



// WEBPACK FOOTER //
// ./www/components/confirmation-order/confirmation-order.js